import * as _ from "lodash/fp";

import { memoize, TS } from "@ctra/utils";

import { TableData } from "../typings";
import { Base } from "./Base";

/**
 * X axis data type weekday class
 */
class WeekDay extends Base {
  /**
   * Format xAxis data
   * @param {T} value
   * @returns {T}
   */
  @memoize
  formatXAxis<T extends number | string>(value: T): T {
    return _.isString(value) ? (TS.asMoment(value).format("dddd") as T) : value;
  }

  /**
   * Format table data
   * @param {TableData["data"]} data
   * @returns {TableData["data"]}
   */
  @memoize
  formatTableData(data: TableData["data"]): TableData["data"] {
    // @ts-expect-error
    return _.sortBy(data, (item) => new Date(item.key).valueOf());
  }
}

export { WeekDay };
